import React from 'react';
import Link from './Link';

import './ChainGameBoard.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { playSound } from '../../utils/audio-helper';

const ChainGameBoard = props => {

  const {
    answers, 
    updateParentGameBoardContent, 
    update, 
    disableLink, 
    revealLinkValue, 
    selectLinkIndex, 
    handleLinkChange, 
    handleLinkFocus, 
    handleLinkKeyPress,
    betLocked,
    bet,
    sounds
  } = props;

  const [gameBoardContent, setGameBoardContent] = useState([]);

  const updateGameBoard = gameBoardContent => {
    setGameBoardContent(gameBoardContent);
    updateParentGameBoardContent(gameBoardContent);
  }

  const populateGameBoardContent = () => {

    const firstIndex = 0,
      lastIndex = answers.length - 1,
      newGameBoardContent = answers.map((answer,i)=>{

        const linkContent = {value: '', disabled: true, answer: answer.trim().toUpperCase(), lastChar: false};

        if (i === firstIndex || i === lastIndex) {
          linkContent.value = answer.trim().toUpperCase();
        }      

        if (i === firstIndex+1 || i === lastIndex-1) {
          linkContent.value = getFirstChar(answer);
          // linkContent.disabled = false;
        }

        return linkContent;
      });
    
    updateGameBoard(newGameBoardContent);
  }

  const getFirstChar = answer => {
    return getAnswerSubString(answer, 1);
  }

  const getAnswerSubString = (answer, indexEnd) => {
    return answer.substring(0, indexEnd).toUpperCase();
  }

  const shouldDisableLink = index => {
    return !shouldEnableLink(index);
  }

  const shouldEnableLink = index => {
    // console.log('this.shouldEnableLink', index, !isLinkSolved(index), isSibLinkSolved(index));

    return !isLinkSolved(index) && isSibLinkSolved(index);
  }

  const isSibLinkSolved = index => isLinkSolved(index+1) || isLinkSolved(index-1);

  const isLinkSolved = index => {
    const { answer, value } = gameBoardContent[index] || {answer:1, value:2};

    // console.log('islinkSolved', value === answer, index,);

    return answer === value;
  }

  const runUpdates = () => {
    const newGameBoardContent = gameBoardContent.map((item, index)=>{

      let disabled = (disableLink && disableLink.type==='DISABLE_LINK_ALL') || shouldDisableLink(index),
        value = item.value,
        selected = selectLinkIndex===index,
        lastChar = item.lastChar,
        status = '';

      // console.log('runUpdates', selectLinkIndex===index, selectLinkIndex, index);

      if (disableLink && disableLink.type==='DISABLE_LINK_UNFOCUSED') {
        disabled = disableLink.index!==index;
      }

      if (revealLinkValue && revealLinkValue.type==='REVEAL_LINK_FIRST_CHAR' && item.value==='' && isSibLinkSolved(index)) {
        value = getAnswerSubString(item.answer, item.value.length + 1);
      }

      if (revealLinkValue && revealLinkValue.type==='REVEAL_LINK_NEXT_CHAR' && revealLinkValue.index===index) {
        value = getAnswerSubString(item.answer, item.value.length + 1);
      }

      if (revealLinkValue && revealLinkValue.type==='REVEAL_LINK_ANSWER' && revealLinkValue.index===index) {
        value = item.answer;
        playSound(sounds, 'correct');
      }

      if (revealLinkValue && revealLinkValue.status!=='' && revealLinkValue.index===index) {
        status = revealLinkValue.status;
      }

      lastChar = value.length === (item.answer.length - 1) ? true : false;

      return Object.assign({}, item, {disabled, value, selected, status, lastChar})
    });

    console.log('runUpdates', newGameBoardContent, disableLink, revealLinkValue);

    updateGameBoard(newGameBoardContent);
  }

  useEffect(()=>{

    populateGameBoardContent();
    playSound(sounds, 'top_bottom');

    playSound(sounds, 'music', {loop: true, fadeInDelay: 9000, volume: 0.4});
  },[]);

  useEffect(()=>{
    if (update) {
      console.log('game board updated');
      runUpdates();
    }

  }, [update, selectLinkIndex]);

  const chainLinks = gameBoardContent.map((item,index) => <Link
      key={'link' + index}
      index={index}
      selected={index===selectLinkIndex}
      disabled={item.disabled}
      value={item.value}
      success={item.status==='STATUS_CORRECT'}
      error={item.status==='STATUS_INCORRECT'}
      handleLinkChange={handleLinkChange}
      handleLinkFocus={handleLinkFocus}
      handleLinkKeyPress={handleLinkKeyPress}
      betLocked={betLocked}
    />
  );

  const cgbClassName = (betLocked ? ' locked': '') + (bet>0? ' has-bet': '');

  return (
    <div className={"chain-game-board" + cgbClassName}>
      {chainLinks}
    </div>
    );
}

export default ChainGameBoard;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/ChainGameBoard.jsx